module.exports = __webpack_public_path__ + "media/ask/logo-text-dark-b4e050a0.svg";